import { useTranslation } from 'react-i18next';
import { SvgIcon } from '@mui/material';

import {
  ActionButton,
  ActionIconButton,
  MainActionButton,
  type ActionButtonProps,
  type ActionIconButtonProps,
  type MainActionButtonProps,
} from '@/components/buttons';
import { ReactComponent as DeleteSVG } from '@/shared/assets/icons-2.0/delete.svg';

export type DeleteMainActionButtonProps = MainActionButtonProps;

export const DeleteMainActionButton = (props: DeleteMainActionButtonProps) => {
  const { t } = useTranslation('actions');

  const { children = t('delete') } = props;

  return (
    <MainActionButton startIcon={<SvgIcon component={DeleteSVG} inheritViewBox fontSize="small" />} {...props}>
      {children}
    </MainActionButton>
  );
};

export type DeleteActionButtonProps = ActionButtonProps;

export const DeleteActionButton = (props: DeleteActionButtonProps) => {
  const { t } = useTranslation('actions');

  const { children = t('delete') } = props;

  return (
    <ActionButton startIcon={<SvgIcon component={DeleteSVG} inheritViewBox fontSize="small" />} {...props}>
      {children}
    </ActionButton>
  );
};

export type DeleteActionIconButtonProps = ActionIconButtonProps;

export const DeleteActionIconButton = (props: DeleteActionIconButtonProps) => {
  const { t } = useTranslation('actions');

  return (
    <ActionIconButton title={t('delete')} {...props}>
      <SvgIcon component={DeleteSVG} inheritViewBox fontSize="medium" />
    </ActionIconButton>
  );
};
